var App = App || {};

App.Bootstrap = (function () {
    'use strict';

    // Initializes Bootstrap element arrays and activates any element referenced by the current URL hash.
    const getElements = (context) => {
        return {
            accordionElements: [...context.querySelectorAll(".accordion-button")]
                .filter(element => element.id)
                .map(element => `#${element.id}`),
            tabElements: [...context.querySelectorAll(".nav-tabs .nav-link")]
                .filter(element => element.id)
                .map(element => `#${element.id}`),
            offcanvasElements: [...context.querySelectorAll(".offcanvas")]
                .flatMap(element => [element.id, element.dataset.hashAlias])
                .filter(Boolean)
                .map(value => `#${value}`.toLowerCase())
        };
    };

    // Activates a Bootstrap element based on the given hash if present in the DOM.
    const activateElement = (context, href) => {
        if (!href || href === "#") return;

        // Determine the type and get the processed candidate
        const bootstrapElements = getElements(context);
        const { type: elementType, candidate: candidate } = resolveElementType(bootstrapElements, href);
        if (!elementType) return;

        // Main logic for different Bootstrap element types
        if (elementType === "accordionElements") {

            const button = context.querySelector(`${candidate}`);
            const panel = context.querySelector(`${candidate}_Target`);
            if (!button || !panel) return;

            const collapse = bootstrap.Collapse.getOrCreateInstance(panel, { toggle: true });
            collapse.show();
            button.focus();

            App.Helpers.scrollToElement(button);
            return true;
        }

        if (elementType === "tabElements") {

            const button = context.querySelector(`${candidate}`);
            if (!button) return;

            const tab = bootstrap.Tab.getOrCreateInstance(button);
            tab.show();
            button.focus();
            App.Helpers.scrollToElement(button);
            return true;
        }

        if (elementType === "offcanvasElements") {

            const value = candidate.slice(1).toLowerCase();
            const offcanvas = [...context.querySelectorAll(".offcanvas")]
                .find(element => element.id.toLowerCase() === value || element.dataset.hashAlias?.toLowerCase() === value);
            if (!offcanvas) return;

            // Close any other open offcanvas (e.g. the mobile menu) before opening the target
            context.querySelectorAll(".offcanvas.show").forEach(element => {
                if (element !== offcanvas) bootstrap.Offcanvas.getInstance(element)?.hide();
            });

            bootstrap.Offcanvas.getOrCreateInstance(offcanvas).show();
            return true;
        }
    };

    // Determines the type of Bootstrap element and returns its type and processed candidate selector.
    const resolveElementType = (bootstrapElements, candidate) => {
        // Return false if candidate is empty
        if (!candidate) return false;

        // Reduce relative or absolute links to the current page down to their hash
        try {
            const url = new URL(candidate, window.location.href);
            const isCurrentPage = url.origin === window.location.origin
                && url.pathname.toLowerCase() === window.location.pathname.toLowerCase()
                && url.search === window.location.search;
            if (!isCurrentPage || !url.hash || url.hash === "#") return false;
            candidate = decodeURIComponent(url.hash);
        } catch {
            return false;
        }

        // Find the type in bootstrapElements
        const type = Object.keys(bootstrapElements).find(key =>
            bootstrapElements[key].includes(key === "offcanvasElements" ? candidate.toLowerCase() : candidate)
        ) ?? false;

        // Return both the type and the processed candidate
        return { type, candidate };
    };

    return {
        activateElement
    };

})();